import React from 'react';
import { classnames } from '../../../../utils/classnames';
import Icon from '../icon/icon';
import './inputs.css';
import InputErrors, {withErrors} from "../inputErrors/inputErrors";
import { useTranslation } from 'react-i18next';
import { autocompleteDisabled } from '../../../../utils/utils';

export default function Input({
    uniqueKey,
    fieldId,
    allow_modification,
    placeholder = '',
    className = '',
    label = null,
    description = null,
    onChange = () => {},
    value = '',
    icon = null,
    disabled = false,
    errors = null,
    required = false,
    maxLength = 600,
    showLength = false,
    display = true,
    subtype,
    autoComplete = null,
    ...rest
}) {
    const { t } = useTranslation();
    const [isFocused, setIsFocused] = React.useState(false);
    const [valueLength, setValueLength] = React.useState(
        value?.length || 0
    );

    const _onChange = React.useCallback(event => {
        if (['ws-2','ws-3'].includes(fieldId) && event.target.value?.length) {
            let val = event.target.value;
            const regex = new RegExp(/^([a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸ'\-\s]+)$/)
            if (!regex.test(val)) {
                return;
            }
            event.target.value = val.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
        }
        if (onChange) {
            onChange(event)
        }
        setValueLength(event.target.value?.length || 0);

    }, [onChange]);

    React.useEffect(() => {
        const confirmationEmail = document.querySelector(".neo-input.confirmation-email");
        if (confirmationEmail) {
            confirmationEmail.addEventListener('paste', e => e.preventDefault());
            return () => {
                confirmationEmail.removeEventListener('paste', e => e.preventDefault());
            };
        }
    }, []);

    const getKey = (element = '') => uniqueKey ? `field_${uniqueKey}${element ? '_' + element : ''}` : null;

    if (!display) {
        return null
    }

    return (
        <div className={classnames('neo-input-content', className)}>
            {label && <label id={getKey('label')} className='neo-input-label'>{label} {required && <span aria-label={t('widget.required-field')} className='neo-input-required'>*</span>}</label>}
            {description && <p className='neo-input-description' id={getKey('description')}>{description}</p>}
            <div className='neo-input-control'>
                {icon && typeof(icon) === 'string' && <Icon name={icon} className='neo-input-icon'/>}
                {icon && typeof(icon) !== 'string' && icon}
                <input
                    onBlur={() => setIsFocused(false)}
                    onFocus={() => setIsFocused(true)}
                    aria-labelledby={getKey('label')}
                    aria-describedby={`${getKey('description')} ${getKey('error')}`} //use describedby for label because placeholder is read anyway
                    aria-invalid={withErrors(errors)}
                    aria-required={false}
                    className={classnames('neo-input', {'error': withErrors(errors), 'disabled': disabled, 'icon': icon, 'confirmation-email': subtype === 'confirmation_email'})}
                    onChange={_onChange}
                    placeholder={!isFocused ? placeholder || label : ''}
                    value={value}
                    disabled={disabled}
                    required={required}
                    maxLength={maxLength}
                    autoComplete={subtype === 'confirmation_email' ? autocompleteDisabled() : autoComplete}
                    {...rest}
                    type={subtype === 'email' ? 'email' : 'text'}
                />
            </div>
            {showLength && (
                <span className="neo-input-length">
                    {valueLength || 0}
                    {maxLength ? `/${maxLength}` : null}
                </span>
            )}
            <InputErrors errors={errors} id={getKey('error')}/>
        </div>
    )
}